import Route from '@ember/routing/route';
import type { Resolved } from 'ember-concurrency';
import type { AppWaldenViewModel } from '../walden-view';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import {
  POWERBI_MAP,
  type PowerBiReportRoute,
} from 'walden-fast/constants/power-bi';
import type { PowerBiReportInternalCode } from 'walden-fast/types/fast-backend/power-bi';
import config from 'walden-fast/config/environment';

type AppWaldenViewDetailRouteParams = { page: string };

export type AppWaldenViewDetailModel = Resolved<
  ReturnType<AppWaldenViewDetailRoute['model']>
>;

type AppWaldenViewRouteParams = { report: PowerBiReportRoute };

export default class AppWaldenViewDetailRoute extends Route {
  @service('router') declare routerService: RouterService;

  parentModelRouteName = 'app.walden-view';

  async beforeModel(transition: Transition): Promise<Transition> {
    const params = transition.to?.parent?.params as AppWaldenViewRouteParams;
    const toPage = transition.to?.params!['page'];
    const toPageIsValid = POWERBI_MAP[params.report]?.pages.some(
      (page) => page.routeName === toPage,
    );

    if (!toPageIsValid) {
      return this.routerService.transitionTo('/not-found', '');
    }
  }

  model(params: AppWaldenViewDetailRouteParams) {
    const parentModel = this.modelFor(
      this.parentModelRouteName,
    ) as AppWaldenViewModel;

    const page = parentModel?.pages?.find(
      (p: { routeName?: string }) => p.routeName === params.page,
    );

    if (
      (parentModel.showcaseContent && !parentModel.userCanAccessService) ||
      !parentModel.report
    ) {
      return {};
    }

    const availableFilters = config.waldenViewAvailableFilter.split(
      ',',
    ) as PowerBiReportInternalCode[];

    return {
      page,
      report: parentModel?.report,
      token: parentModel?.token,
      userCanAccessFilters: availableFilters.includes(
        parentModel?.report.internalCode,
      ),
    };
  }
}
